import { Trophy } from "lucide-react";
import { Reveal, Kicker } from "./shared";

export default function Award() {
  return (
    <section id="oceneni" className="relative overflow-hidden bg-white py-24 sm:py-32" data-testid="award-section">
      <div className="spotlight absolute inset-0" aria-hidden="true" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-2">
        <Reveal>
          <div className="group relative mx-auto max-w-md overflow-hidden rounded-lg border border-stone-200 bg-[#FAF7F2] shadow-sm">
            <img
              src="/img/award-wcia.png"
              alt="World Coffee Innovation Awards 2025 — vítěz kategorie Roasting Innovation"
              loading="lazy"
              className="w-full object-contain p-8 transition-transform duration-[1.6s] ease-out group-hover:scale-105"
              data-testid="award-badge-image"
            />
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="flex items-center gap-3">
            <Trophy className="h-6 w-6 text-gold" aria-hidden="true" />
            <Kicker>Ocenění</Kicker>
          </div>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl md:text-5xl">
            World Coffee Innovation Awards 2025
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-stone-600 sm:text-lg">
            BeanGo Cube® X zvítězil v kategorii <span className="font-bold text-gold">Roasting Innovation</span> na
            prestižních World Coffee Innovation Awards 2025 v Londýně.
          </p>
          <p className="mt-6 text-sm leading-relaxed text-stone-500">
            Značku BeanGo Cube® navrhuje a vyrábí tchajwanská společnost Jiyonson. Pro Českou
            republiku a Slovensko zajišťujeme výhradní dovoz, předvedení i podporu.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
